import React, { useState } from "react";
import "./login.css";
import { Link } from "react-router-dom";
import "react-toastify/dist/ReactToastify.css";
import { Container, Row, Col, Image } from "react-bootstrap";
import { TextFieldIcon } from "../Common/FormComponents/TextFieldIcon";
import * as Yup from "yup";
import { Formik, Form } from "formik";
import packageJson from "../../../package.json";

function Login(props) {
  const [pswrdVisible, setPswrdVisible] = useState(false);
  const copyrightYear = new Date().getFullYear();

  const checkpswrdVisible = () => {
    setPswrdVisible(!pswrdVisible);
  };

  const validate = Yup.object({
    username: Yup.string().required("User id is required"),
    password: Yup.string()
      .required("Password is required")
      .min(6, "Password must be at least 6 characters long"),
  });

  const isWindows = navigator.platform.includes("Win");

  return (
    <Formik
      initialValues={{
        username: "",
        password: "",
      }}
      validationSchema={validate}
      onSubmit={(values) => {
        props.logins(values);
      }}
    >
      {(formik) => (
        <div className={isWindows ? "backgroundscreenwin" : "backgroundscreen"}>
          <div className="backgroundbott mt-1">
            <Container>
              <div className="cardMainlogin">
                <Row>
                  <Col xs={12} md={12} sm={12} lg={6}>
                    <div>
                      <Image
                        alt="loginimage"
                        className="loginimage"
                        src={require("../../assets/img/Artboard_2.jpg")}
                      />
                    </div>
                  </Col>
                  <Col xs={12} md={12} sm={12} lg={6}>
                    <Container>
                      <div className="loginheaderfrst">
                        <div className="loginLogo">
                          <div>
                            <img
                              alt="logo1"
                              className="logo1"
                              src={require("../../assets/img/logo-sh.png")}
                            />
                          </div>
                          <div className="vl"></div>
                          <div>
                            <img
                              alt="logo2"
                              className="wateronlogo"
                              src={require("../../assets/img/waterOn_logo.png")}
                            />
                          </div>
                        </div>
                        <h3 className="loginTitle">Hello! Welcome Back</h3>
                        <div className="loginform">
                          <Form>
                            <div>
                              <TextFieldIcon
                                placeholder="enter user id "
                                name="username"
                                type="text"
                                label="User Id"
                                icon="fa fa-at textFieldicon"
                              />
                            </div>
                            <div>
                              <TextFieldIcon
                                placeholder="enter password"
                                name="password"
                                type={pswrdVisible ? "text" : "password"}
                                label="Password"
                                icon="fa fa-unlock textFieldicon"
                                eyeicon={
                                  pswrdVisible
                                    ? "fa fa-eye-slash textFieldeyeicon"
                                    : "fa fa-eye textFieldeyeicon"
                                }
                                iconClick={checkpswrdVisible}
                              />
                            </div>
                            <div className="forgotPswddiv">
                              <Link to="/forgotpassword" className="forgotPswd">
                                Forgot your password
                              </Link>
                            </div>
                            <button className="contactpagebtn" type="submit">
                              Login
                            </button>
                          </Form>
                        </div>
                      </div>
                    </Container>
                  </Col>
                </Row>
              </div>
              <div className="footerclass">
                <div></div>
                <div className="loginDivVersion">
                  <span>
                    Copyright © {new Date().getFullYear()} by SmarterHomes
                    Private Ltd. All Rights Reserved.{" "}
                    {process.env.REACT_APP_VERSION}
                    {/* Version {packageJson.version}© {copyrightYear} SmarterHomes
                    Technologies */}
                  </span>
                </div>
              </div>
            </Container>
          </div>
        </div>
      )}
    </Formik>
  );
}

export default Login;
